module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/pdf-viewer/pdf-viewer.component.scss
// module id = ./src/app/modules/common-module/common/pdf-viewer/pdf-viewer.component.scss
// module chunks = 9